export const COMMUNICATION_CATEGORIES = [
    'Payment',
    'Invoice',
    'Statement',
    'Buy',
    'Sell',
    'Shares',
    'Request',
    'Support',
    'Meeting',
    'Marketing',
    'Spam',
    'Legal',
    'HR',
    'Urgent',
    'Finance',
    'Tax',
    'Insurance',
    'Investment',
    'Compliance',
    'Purchase Order',
    'General',
];
